import React, { memo, ReactNode } from 'react';
import { DOMProps } from '@react-types/shared';

import { TestProps } from '../../internal/types/testTypes';
import { cn } from '../../lib/css/className/className';
import './UserBar.css';
import { VStack } from '../Stack';

export const cnUserBar = cn('UserBar');

export interface UserBarProps extends TestProps, DOMProps {
    /**
     * Внутренее наполнение UserBar
     * состоящее из верхней и нижней секции
     * @expectedNode `UserBarTopSection` | `UserBarBottomSection` | `UserBarPopup`
     */
    children: ReactNode;
    /**
     * Дополнительный класс для юзербара
     */
    className?: string;
}

/**
 * Компонент UserBar
 */
export const UserBar = memo<UserBarProps>(function UserBar({ children, className, 'data-testid': dataTestId }) {
    return (
        <VStack className={cnUserBar({}, [className])} data-testid={dataTestId} justifyContent="space-between">
            {children}
        </VStack>
    );
});
